// Helper for fetching (potentially) stale datastructure from localstorage
export const fromLocal = <T>(key: string): T | undefined => {
  let local = localStorage.getItem(key);
  if (!local) return;
  return JSON.parse(local) as unknown as T;
};
